import { createI18n } from "vue-i18n";

import cs from "../locales/cs.json";
import de from "../locales/de.json";
import fr from "../locales/fr.json";
import hu from "../locales/hu.json";
import it from "../locales/it.json";
import pl from "../locales/pl.json";
import ro from "../locales/ro.json";
import sk from "../locales/sk.json";

const lang = import.meta.env?.VITE_VUE_APP_LOCALE ?? "cs";

export const i18n = createI18n({
    legacy: false,
    locale: lang,
    fallbackLocale: "cs",
    messages: { cs, sk, pl, hu, ro, de, fr, it },
    pluralRules: {
        cs: (count) => (count === 1 ? 0 : count >= 2 && count <= 4 ? 1 : 2),
    },
    datetimeFormats: {
        cs: {
            long: {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                weekday: "long",
                hour: "numeric",
                minute: "numeric",
            },
        },
    },
});
